// Subscription grace period in days
export const SUBSCRIPTION_GRACE_PERIOD_DAYS = 7;

// Helper to add days to a date
export const addDays = (date: Date, days: number): Date => {
	const result = new Date(date);
	result.setDate(result.getDate() + days);
	return result;
};
